import { useEffect, useState } from "react";
import { _DocumentFactory, _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _ProductCost } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProductEditor } from "../../ManufacturingStandars/Components/SelectProductEditor";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { ErrorList } from "../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { DropDown } from "../../../theme/Component/DropDown";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";

interface Props {
    isModal?: boolean;
    idProduct?: number;
}

interface filter {
    ProductID: number;
    FromDate: any;
    UptoDate: any;
    IDStoreDestinity: number;
}

export const ProductCost = ({ idProduct, isModal }: Props) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_ProductCost);
    const doc = useDataBean(_DocumentFactory);
    const [filter, setFilter] = useState<Partial<filter>>({
        ProductID: idProduct
    });

    const modalDocument = useModal("Documento", MODAL_XL);
    const modalAdd = useModal("", MODAL_md);
    const modalEdit = useModal(`Editar Costo de Producto`, MODAL_md);
    const modalDelete = useModal("Eliminar costo de Producto", MODAL_md);
    const modalCalculate = useModal("Costo de Producto", MODAL_md);
    const modalCalculatedCost = useModal("Resultado del Costo de Producto", MODAL_LG);
    const modalRecost = useModal("Generar Recosteo de Producto", MODAL_md);
    const modalRecalculate = useModal("Recalcular Costeo de Producto", MODAL_md);
    const [calculate, setCalculate] = useState<any>({ ValidateQuantities: false });
    const [calculatedCost, setCalculatedCost] = useState<any>(null);
    const [recost, setRecost] = useState<any>({});

    const getLista = () => {
        instance.getProductCostHistory(filter.ProductID, filter.IDStoreDestinity, filter.FromDate, filter.UptoDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => toast.error(err))

    }

    const create = () => {
        setBean({
            IDProduct: idProduct
        });
        modalAdd.setModal({ ...modalAdd.modal, view: true, name: "Agregar Costo de Producto" });
    }

    const deleteItem = () => {
        instance.deleteProductCost(bean.IDCost).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const addItems = () => {
        instance.addProductCost(bean.IDProduct, bean.ProductCost, bean.From).then(
            (resp) => {
                modalAdd.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const updateItems = () => {
        instance.updateProductCost(bean).then(
            (resp: any) => {
                modalEdit.close();
                getLista();
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const recalculateDocument = () => {
        if (!bean.IDDocument) {
            toast.error("No se encuentra documento asociado");
            return;
        }
        instance.parseNewProductCostForDocument(bean.IDDocument, bean.Since).then(() => {
            toast.success("Costeo del producto recalculado correctamente");
            modalRecalculate.close();
            getLista();
        }).catch((err: any) => toast.error(err));
    }

    const calculateProductCost = () => {
        if (!calculate.IDProduct || !calculate.Date) {
            toast.warning("Debe seleccionar el producto y la fecha de corte");
            return;
        }
        instance.getProductCostForProduct(calculate.IDProduct, calculate.IDStore, calculate.Date, calculate.ValidateQuantities ?? false)
            .then((resp: any) => {
                const productCost = resp?.ObjectValue?.DataBeanProperties ?? resp?.DataBeanProperties ?? resp;
                setCalculatedCost(productCost);
                getLista();
                modalCalculate.close();
                modalCalculatedCost.open();
            })
            .catch((err: any) => toast.error(err));
    }

    const generateRecost = () => {
        if (!recost.IDProduct || !recost.From) {
            toast.warning("Debe seleccionar el producto y la fecha inicial de recosteo");
            return;
        }
        instance.parseReCostForProduct(recost.IDProduct, recost.From).then(() => {
            toast.success("Recosteo del producto generado correctamente");
            modalRecost.close();
            getLista();
        }).catch((err: any) => toast.error(err));
    }

    const actionsDropDown = [
        { id: 1, name: 'Costo de Producto', permiso: null, activo: true },
        { id: 2, name: 'Generar Recosteo de Producto', permiso: null, activo: true },
    ];

    const actions = (e: any) => {
        if (e.id === 1) {
            setCalculatedCost(null);
            setCalculate({ ValidateQuantities: false });
            modalCalculate.open();
        }
        if (e.id === 2) {
            setRecost({});
            modalRecost.open();
        }
    }

    const buttons = () => <DropDown lista={actionsDropDown} eventClick={actions} />;

    const calculatedCostFields = [
        { label: "ID Costo", property: "IDCost" },
        { label: "ID Documento", property: "IDDocument" },
        { label: "Documento", property: "Mnemonic" },
        { label: "ID Producto", property: "IDProduct" },
        { label: "ID Almacén", property: "IDStore" },
        { label: "ID Cuenta", property: "IDAccount" },
        { label: "ID Lote", property: "IDLot" },
        { label: "Fecha Desde", property: "Since" },
        { label: "Fecha Hasta", property: "Upto" },
        { label: "Costo de Producto", property: "ProductCost" },
        { label: "Valor Unitario", property: "UnitaryValue" },
        { label: "Valor de Venta", property: "SellValue" },
        { label: "Cantidad Transacción", property: "TrQuantity" },
        { label: "Costo Transacción", property: "TrCost" },
        { label: "Cantidad Total", property: "TotalQuantity" },
        { label: "Costo Total", property: "TotalCost" },
        { label: "Cantidad Restante", property: "LeftQuantity" },
        { label: "Valor Restante", property: "LeftValue" },
    ];

    const showValue = (value: any) => value === null || value === undefined || value === "" ? "N/A" : value;
    const head = [
        { title: 'ID', property: 'IDCost', visible: true, mask: MASK_NUMBER },
        { title: 'Documento', property: 'Mnemonic', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Cantidad Ingresa', property: 'TrQuantity', visible: true },
        { title: 'Valor Ingreso', property: 'TrCost', visible: true },
        { title: 'Valor Unitario', property: 'UnitaryValue', visible: true },
        { title: 'Cantidad Total', property: 'TotalQuantity', visible: true },
        { title: 'Valor Total', property: 'TotalCost', visible: true },
        { title: 'Costo Producto', property: 'ProductCost', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit, evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open(); } },
            { titulo: 'Ver Documento', icono: 'ri-folder-4-line', visible: bean.IDDocument, evento: () => { getDocument(); } },
            { titulo: 'Recalcular Costeo de producto', icono: 'ri-refresh-line', visible: true, evento: () => { modalRecalculate.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateDataFilter = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            getLista();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "ProductID", "FromDate", "UptoDate"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (filter[field] === null || filter[field] === undefined || filter[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const [response, setResponse] = useState<any>({});
    const [msgList, setMsgList] = useState<any>([]);

    const getDocument = () => {
        doc.instance.getAccountantDocumentByLocation(bean.IDDocument, bean.Since).then(
            (resp) => {

                doc.setLista(resp.DocumentURL)
                setResponse(resp)
                setMsgList(resp.MsgList);
            }
        )
    }

    useEffect(() => {
        if (doc.lista.length > 0) {
            modalDocument.open();
        }
    }, [doc.lista])

    const renderReturn = () => {
        return (
            <div className="row">
                {!idProduct &&
                    <div className="col-md-4">
                        <label className={`${missingFields.includes('ProductID') ? 'has-error' : ''}`}>Seleccione un Producto</label>
                        <SelectProductEditor label=" " value={filter.ProductID} onChange={(e) => { setFilter({ ...filter, ProductID: e.IDProduct }) }} />
                    </div>
                }
                <div className="col-md-4">
                    <SelectStoreEditor label="Almacen" idSelector={filter.IDStoreDestinity} onChange={(e) => { setFilter({ ...filter, IDStoreDestinity: e.IDStore }) }} />
                </div>
                <div className="col-md-4">
                    <label className={`${missingFields.includes('FromDate') ? 'has-error' : ''}`}>Fecha desde</label>
                    <InputDate name="" value={filter.FromDate} label=" " setDate={(e) => setFilter({ ...filter, FromDate: e })} />
                </div>
                <div className="col-md-4">
                    <label className={`${missingFields.includes('UptoDate') ? 'has-error' : ''}`}>Fecha hasta</label>
                    <InputDate name="" value={filter.UptoDate} label=" " setDate={(e) => setFilter({ ...filter, UptoDate: e })} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton eventClick={validateDataFilter} icon="ri-search-line" children={"Buscar"} />
                </div>
                <div className="col-md-12">
                    {!isModal && buttons()}
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>

                    <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={addItems}>
                        <div className="row">
                            {!idProduct &&
                                <div className="col-md-12">
                                    <SelectProductEditor label="Producto" value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct, "Name": e.Description, "StockKeepingUnit": e.StockKeepingUnit, "IDMeasurementUnit": e.IDMeasurementUnit }) }} />
                                </div>
                            }
                            <div className="col-md-6">
                                <label>Costo de Producto</label>
                                <InputMoney _value={bean.ProductCost} onChange={(e) => { setBean({ ...bean, ProductCost: e }) }} _label=" " />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="" value={bean.From} label="Fecha desde" setDate={(e) => { setBean({ ...bean, "From": e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={updateItems}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Costo de Producto</label>
                                <InputMoney _value={bean.ProductCost} onChange={(e) => { setBean({ ...bean, ProductCost: e }) }} _label=" " />
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.IDCost}</strong>
                    </ModalConfirm>

                    <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} >
                        <div className="row">
                            <div className="col">
                                {msgList.length > 0 &&
                                    <ErrorList lista={msgList} />
                                }
                                {msgList.length === 0 && lista.length > 0 &&
                                    <DocumentViewer key={doc.lista} list={doc.lista} />
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalCalculate.modal} updateModal={modalCalculate.setModal} eventModal={calculateProductCost}>
                        <div className="row">
                            <div className="col-md-12"><SelectProductEditor label="Producto" value={calculate.IDProduct} onChange={(e) => setCalculate({ ...calculate, IDProduct: e.IDProduct })} /></div>
                            <div className="col-md-12"><SelectStoreEditor label="Almacén" idSelector={calculate.IDStore} onChange={(e) => setCalculate({ ...calculate, IDStore: e.IDStore })} /></div>
                            <div className="col-md-6"><InputDate name="Date" label="Fecha de Corte" value={calculate.Date} setDate={(e) => setCalculate({ ...calculate, Date: e })} /></div>
                            <div className="col-md-6"><BasicSwitch label="Validar Valores de Contabilidad" estado={calculate.ValidateQuantities ?? false} eventChange={(e) => setCalculate({ ...calculate, ValidateQuantities: e })} /></div>
                        </div>
                    </Modal>
                    <Modal modal={modalCalculatedCost.modal} updateModal={modalCalculatedCost.setModal}>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <tbody>
                                    {Array.from({ length: Math.ceil(calculatedCostFields.length / 2) }, (_, index) => {
                                        const first = calculatedCostFields[index * 2];
                                        const second = calculatedCostFields[index * 2 + 1];
                                        return <tr key={first.property}>
                                            <th style={{ width: "20%" }}>{first.label}</th>
                                            <td style={{ width: "30%" }}>{showValue(calculatedCost?.[first.property])}</td>
                                            {second && <><th style={{ width: "20%" }}>{second.label}</th><td style={{ width: "30%" }}>{showValue(calculatedCost?.[second.property])}</td></>}
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Modal>
                    <Modal modal={modalRecost.modal} updateModal={modalRecost.setModal} eventModal={generateRecost}>
                        <div className="row">
                            <div className="col-md-12"><SelectProductEditor label="Producto" value={recost.IDProduct} onChange={(e) => setRecost({ ...recost, IDProduct: e.IDProduct })} /></div>
                            <div className="col-md-12"><InputDate name="From" label="Fecha inicial Recosteo" value={recost.From} setDate={(e) => setRecost({ ...recost, From: e })} /></div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalRecalculate.modal} updateModal={modalRecalculate.setModal} eventModal={recalculateDocument}>
                        <strong>¿Desea recalcular el costeo del documento {bean.IDDocument}?</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ? (
                renderReturn()
            ) : (
                <BasicPage titulo="Costos de Producto">
                    {renderReturn()}
                </BasicPage>
            )}
        </>
    )

}
